module.exports = __webpack_public_path__ + "img/Filatech_luminous_orange.ebb32722.jpg";